import { Card, Avatar, Row, Col, Button, Grid } from "antd";
import { SmileOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { QUIZ_RESULT_VIEW } from "../../../../../apis/apis";

const { useBreakpoint } = Grid;

function QuizResult() {
    const { chapter_id } = useParams();
    const navigate = useNavigate();
    const screens = useBreakpoint();

    const [loading, set_loading] = useState(false);
    const [result, set_result] = useState(null);
    const [image, set_image] = useState("");

    useEffect(() => {
        const VIEW_API = async () => {
            set_loading(true);
            const FORM_DATA = new FormData();
            FORM_DATA.append("chapter_id", atob(chapter_id));
            try {
                const response = await QUIZ_RESULT_VIEW(FORM_DATA);
                if (response?.data?.status) {
                    const data = response.data?.data;
                    set_result(data);
                    if (data.image) {
                        set_image(data.image);
                    }
                }
            } catch (err) {
                console.error("Error fetching quiz result:", err);
            }
            set_loading(false);
        };
        VIEW_API();
    }, [chapter_id]);

    if (loading || !result) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100vh",
                    color: "#fff",
                    padding: 16,
                    textAlign: "center",
                }}
            >
                Loading your result...
            </div>
        );
    }

    // 🧮 Formatting time
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins < 10 ? "0" + mins : mins} mins ${secs < 10 ? "0" + secs : secs} sec`;
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                padding: 16,
            }}
        >
            <Card
                style={{
                    width: "100%",
                    maxWidth: 1000,
                    minHeight: screens.md ? 500 : "auto",
                    textAlign: "center",
                    borderRadius: 12,
                    border: "1px solid gray",
                }}
            >
                {/* Image / Avatar */}
                {image ? (
                    <img
                        src={image}
                        alt="avatar"
                        style={{
                            width: screens.md ? 100 : 80,
                            height: screens.md ? 100 : 80,
                            borderRadius: "50%",
                            objectFit: "cover",
                            marginBottom: 16,
                            marginTop: 16,
                        }}
                    />
                ) : (
                    <Avatar
                        size={screens.md ? 100 : 80}
                        icon={<SmileOutlined />}
                        style={{
                            backgroundColor: "#fadb14",
                            marginBottom: 16,
                            marginTop: 16,
                        }}
                    />
                )}

                <h2 style={{ color: "#fff", fontSize: screens.md ? 22 : 18 }}>
                    {result.passing_status
                        ? "Congratulations! You passed the quiz!"
                        : "Take on that quiz again and crack it like a boss!"}
                </h2>

                <h3 style={{ color: "#40a9ff", fontSize: screens.md ? 18 : 16 }}>
                    Score: {result.score}
                </h3>

                <p style={{ color: "#aaa", marginTop: 12 }}>
                    Here’s a breakdown of your performance
                </p>

                {/* Stats */}
                <Row justify="center" gutter={[16, 16]} style={{ marginTop: 20 }}>
                    <Col xs={12} sm={12} md={6}>
                        <div style={{ display: "flex", justifyContent: "center", marginBottom: 6 }}>
                            <span style={{ width: 12, height: 12, backgroundColor: "green", borderRadius: "50%", marginRight: 8 }} />
                            <span>Correct Answers</span>
                        </div>
                        <div style={{ fontSize: 16 }}>
                            <span style={{ color: "green" }}>
                                {result.correct_answers < 10
                                    ? `0${result.correct_answers}`
                                    : result.correct_answers}
                            </span>
                        </div>
                    </Col>

                    <Col xs={12} sm={12} md={6}>
                        <div style={{ display: "flex", justifyContent: "center", marginBottom: 6 }}>
                            <span style={{ width: 12, height: 12, backgroundColor: "red", borderRadius: "50%", marginRight: 8 }} />
                            <span>Wrong Answers</span>
                        </div>
                        <div style={{ fontSize: 16 }}>
                            <span style={{ color: "red" }}>
                                {result.wrong_answers < 10
                                    ? `0${result.wrong_answers}`
                                    : result.wrong_answers}
                            </span>
                        </div>
                    </Col>

                    <Col xs={12} sm={12} md={6}>
                        <div style={{ display: "flex", justifyContent: "center", marginBottom: 6 }}>
                            <span style={{ width: 12, height: 12, backgroundColor: "#fadb14", borderRadius: "50%", marginRight: 8 }} />
                            <span>Time Spent</span>
                        </div>
                        <div style={{ fontSize: 16 }}>
                            <span style={{ color: "#fadb14" }}>
                                {formatTime(result.time_spent)}
                            </span>
                        </div>
                    </Col>

                    <Col xs={12} sm={12} md={6}>
                        <div style={{ display: "flex", justifyContent: "center", marginBottom: 6 }}>
                            <span style={{ width: 12, height: 12, backgroundColor: "#40a9ff", borderRadius: "50%", marginRight: 8 }} />
                            <span>Percentage</span>
                        </div>
                        <div style={{ fontSize: 16 }}>
                            <span style={{ color: "#40a9ff" }}>
                                {result.percentage}%
                            </span>
                        </div>
                    </Col>
                </Row>

                {/* Buttons */}
                {result.passing_status ? (
                    <Button
                        type="primary"
                        size="large"
                        style={{
                            marginTop: 28,
                            width: screens.md ? "auto" : "100%",
                        }}
                        onClick={() => {
                            navigate("/courses");
                            setTimeout(() => {
                                window.close();
                            }, 0.1);
                        }}
                    >
                        Close
                    </Button>
                ) : (
                    <Button
                        color="red"
                        variant="solid"
                        size="large"
                        style={{
                            marginTop: 28,
                            width: screens.md ? "auto" : "100%",
                            border: "none",
                        }}
                        onClick={() => {
                            navigate("/chapters");
                            setTimeout(() => {
                                window.close();
                            }, 0.1);
                        }}
                    >
                        Re-attempt Quiz
                    </Button>
                )}
            </Card>
        </div>
    );
}

export default QuizResult;
